export const REQUEST_ID_HEADER = "X-Request-ID";
export const CORRELATION_ID_HEADER = "X-Correlation-ID";

export function generateRequestId(): string {
    return crypto.randomUUID();
}

export function withRequestId(headers: Record<string, string>): Record<string, string> {
    return {
        ...headers,
        [REQUEST_ID_HEADER]: generateRequestId(),
    };
}
